import { SendMessageType } from "../types";
export function storeItems(messageType, messageCache, items) {
    if (messageType === SendMessageType.Clear) {
        messageCache[messageType].items = [];
    }
    else {
        messageCache[messageType].items = items;
    }
}
//# sourceMappingURL=storeItems.js.map